import React, { useState } from "react";

// External Package
import { useSelector } from "react-redux";

// State
import { RootState } from "../../store/authStore";

// Source
import { getPackages } from "../../source/servicePackagesSource";
import { BALE_THEME_URL } from "../../source/links";

// i18n
import { useTranslation, whatsappLink } from "../../i18n";

const DEFAULT_PACKAGE_ID = 2; // Professional

export default function ServicePackagesComponents() {
  // variable
  const isMobile = useSelector((state: RootState) => state.auth.isMobile);
  const { lang, t } = useTranslation();
  const packages = getPackages(lang);
  const [selectedId, setSelectedId] = useState<number>(DEFAULT_PACKAGE_ID);
  const selected =
    packages.find((item) => item.id === selectedId) ?? packages[0];

  // function
  const handleOrderClick = () => {
    window.open(
      whatsappLink(t.services.orderMessage(selected.label, selected.priceFull)),
      "_blank"
    );
  };

  const handleOrderCustomClick = () => {
    window.open(whatsappLink(t.services.customMessage), "_blank");
  };

  const packageCards = (colClass: string) =>
    packages.map((item) => (
      <div className={colClass} key={item.id}>
        <div
          className={`packages p-4 d-flex flex-column text-center ${
            item.id === selected.id ? "active-packages" : ""
          }`}
        >
          <label
            htmlFor={item.label}
            className="title font-size-28 font-vietnam-600"
          >
            {item.label}
          </label>
          <div className="price mt-2">
            <label
              htmlFor=""
              className="font-size-36 d-flex justify-content-center text-nowrap"
            >
              <span className="font-size-14">{item.currency}</span>
              {item.price}
            </label>
            <div className="years mt-1 font-vietnam-200-italic">
              {item.duration}
            </div>
          </div>
          <button
            className="btn btn-detail-outline rounded-0 mt-2"
            onClick={() => setSelectedId(item.id)}
          >
            {t.services.detail}
          </button>
        </div>
      </div>
    ));

  const templateHint = (
    <p className="font-size-14 font-vietnam-300-italic mb-0">
      {t.services.customTemplateHint}{" "}
      <a
        href={BALE_THEME_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="font-vietnam-600 text-reset"
      >
        bale-theme.my.id
      </a>
      .
    </p>
  );

  const customIntro = (
    <>
      <label htmlFor="" className="title font-size-28 font-vietnam-600">
        {t.services.customTitle}
      </label>
      <p className="font-size-18 font-vietnam-200-italic">
        {t.services.customBody}
      </p>
      {templateHint}
    </>
  );

  const detailPanel = (
    <>
      <div className="title font-size-36 font-vietnam-600">
        {" "}
        {t.services.packagePrefix} {selected.label}{" "}
      </div>
      <div className="content">
        {selected.features.map((feature, index) => (
          <div className="row" key={index}>
            <div className="col-6 describe font-size-18 font-vietnam-600">
              {feature.describe}
            </div>
            <div className="col-6 value text-center">
              {feature.active && feature.value !== "approved" ? (
                feature.value
              ) : (
                <img
                  src={require("../../assets/icons/approve.png")}
                  alt="✓"
                  width={30}
                  height={30}
                  loading="lazy"
                />
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="row">
        <div className="col-12">
          <button
            className="btn btn-detail w-100 rounded-0 mt-2"
            onClick={handleOrderClick}
          >
            {t.services.orderNow}
          </button>
        </div>
      </div>
    </>
  );

  return (
    <div className="services_content_packages mt-5">
      <div className="header">
        <h2 className="font-vietnam-600">{t.services.packagesTitle}</h2>
        <label htmlFor="" className="font-vietnam-200-italic">
          {t.services.packagesBody}
        </label>
      </div>
      {isMobile ? (
        <div className="content mt-5">
          <div className="row">
            <div className="col-12 mb-5">
              <div className="content_packages">
                <div className="row">{packageCards("col-12 mb-4")}</div>
                <div className="content_packages_custom">
                  <div className="row">
                    <div className="col-12">
                      <div className="packages_custom">{customIntro}</div>
                      <button
                        className="btn btn-detail rounded-0 mt-2 w-100"
                        onClick={handleOrderCustomClick}
                      >
                        {t.services.discuss}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 mt-5">
              <div className="content_detail_packages mb-4">{detailPanel}</div>
            </div>
          </div>
        </div>
      ) : (
        <div className="content mt-5">
          <div className="row">
            <div className="col-5">
              <div className="content_detail_packages">{detailPanel}</div>
            </div>
            <div className="col-7">
              <div className="content_packages">
                <div className="row">{packageCards("col-4")}</div>
                <div className="content_packages_custom">
                  <div className="row">
                    <div className="col-12">
                      <div className="packages_custom">
                        {customIntro}
                        <button
                          className="btn btn-detail rounded-0 mt-2"
                          onClick={handleOrderCustomClick}
                        >
                          {t.services.discuss}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
